import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TemplateFacade } from "src/app/services/template.facade";
import { SubSink } from "subsink";
import { AbstractCirculationsService } from "../../interfaces";
import { ICirculationTemplate } from "../../interfaces/circulation";
import { LogClass, Logger } from "../../logger";
import { NavigationService } from "../../services/navigation.service";

@Component({
    selector: "circ-edit-metadata",
    templateUrl: "./edit-metadata.component.html",
    styleUrls: ["./edit-metadata.component.scss"],
    standalone: false
})
@LogClass({
  source: "Template/EditMetadataComponent"
})
export class EditMetadataComponent implements OnInit, OnDestroy {
  public loading = true;
  private logger: Logger;
  private subscriptions = new SubSink();
  public template: ICirculationTemplate;

  constructor(
    private navigate: NavigationService,
    private route: ActivatedRoute,
    private circulationService: AbstractCirculationsService,
    private templateFacade: TemplateFacade
  ) {
    this.logger.debug("ctor");
  }

  ngOnInit(): void {
    this.subscriptions.sink = this.templateFacade
      .getCurrentTemplate()
      .subscribe(
        (template) => {
          this.logger.info("loaded template:" + template.id);
          this.template = template;
          this.loading = false;
        },
        (err) => {
          this.logger.error("loading template", err);
          this.loading = false;
          this.navigate.toError(err);
        }
      );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onSave(template: ICirculationTemplate): void {
    this.subscriptions.sink = this.circulationService
      .SaveCirculationTemplate(template)
      .subscribe((id) => {
        this.logger.info("saved:" + id);
        this.navigate.toTemplate(id);
      });
  }

  public onAbort(): void {
    this.navigate.toTemplate(this.template.id);
  }
}
